export enum DashboardStatistic {
  TOTAL_REVENUE = "Total Revenue",
  LOTS = "Lots",
  BIDS = "Bids",
  INVOICES = "Invoices"
}
